<section class="min-h-screen bg-slate-50 dark:bg-dark-900">
  <div class="mx-auto flex w-full max-w-3xl flex-col gap-8 px-4 py-10">
    @if (isLoading()) {
    <div class="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5 dark:bg-dark-800">
      <p class="animate-pulse text-sm text-gray-500 dark:text-gray-400">
        Cargando detalles de tu cita...
      </p>
    </div>
    } @else if (errorMessage()) {
    <div class="rounded-2xl bg-white p-6 text-center shadow-sm ring-1 ring-red-200 dark:bg-dark-800">
      <p class="text-sm text-red-600 dark:text-red-400">{{ errorMessage() }}</p>
    </div>
    } @else if (event()) {
    <div class="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5 dark:bg-dark-800">
      <div class="space-y-4">
        @if (event()?.businessLogoUrl) {
        <div class="flex items-center justify-center">
          <img
            [src]="event()?.businessLogoUrl"
            [alt]="event()?.businessName || 'Logo del negocio'"
            class="h-16 w-auto object-contain"
          />
        </div>
        }
        <div>
          <p class="text-sm font-semibold uppercase text-brand-500">
            Tu cita con {{ event()?.businessName }}
          </p>
          <h1 class="text-2xl font-semibold text-gray-900 dark:text-white/90">
            {{ event()?.serviceName }}
          </h1>
          <p class="text-sm text-gray-500 dark:text-gray-300">
            Profesionista: {{ event()?.professionalName || 'Por confirmar' }}
          </p>
          <div class="mt-3 flex items-center gap-2">
            @if (statusBadge()) {
            <span
              class="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold text-white"
              [style.background-color]="statusBadge()?.color"
            >
              {{ statusBadge()?.label }}
            </span>
            }
          </div>
        </div>
        <div class="rounded-xl border border-gray-200 bg-gray-50/70 p-4 dark:border-dark-600 dark:bg-dark-700/40">
          <p class="text-sm font-semibold text-gray-700 dark:text-gray-200">
            Detalle del evento
          </p>
          <ul class="mt-3 space-y-2 text-sm text-gray-600 dark:text-gray-300">
            <li>
              <span class="font-medium text-gray-800 dark:text-white/90">Fecha y hora:</span>
              {{ event()?.startDate | date:'EEEE, d MMMM y, h:mm a' }}
            </li>
            <li>
              <span class="font-medium text-gray-800 dark:text-white/90">Duración estimada:</span>
              {{ (event()?.endDate | date:'shortTime') }} (aprox.)
            </li>
            <li>
              <span class="font-medium text-gray-800 dark:text-white/90">Cliente:</span>
              {{ event()?.clientName }} · {{ event()?.clientEmail }}
            </li>
            @if (event()?.serviceDescription) {
            <li>
              <span class="font-medium text-gray-800 dark:text-white/90">Descripción:</span>
              {{ event()?.serviceDescription }}
            </li>
            }
          </ul>
        </div>

        <div class="flex flex-col gap-3 sm:flex-row sm:justify-end">
          <button
            type="button"
            class="inline-flex items-center justify-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-dark-600 dark:text-gray-200 dark:hover:bg-dark-700"
            [disabled]="isProcessing() || isCancelled()"
            (click)="cancel()"
          >
            @if (isProcessing()) { Procesando... } @else { Cancelar cita }
          </button>
          <button
            type="button"
            class="inline-flex items-center justify-center rounded-lg bg-brand-500 px-6 py-2 text-sm font-medium text-white shadow hover:bg-brand-600 disabled:cursor-not-allowed disabled:bg-brand-500/60"
            [disabled]="isProcessing() || isConfirmed() || isCancelled()"
            (click)="confirm()"
          >
            @if (isProcessing()) { Procesando... } @else { Confirmar asistencia }
          </button>
        </div>
      </div>
    </div>
    }
    <div class="text-center text-xs text-gray-500 dark:text-gray-400">
      Powered by <strong>CitaLink Pro</strong>
    </div>
  </div>
</section>
